var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-copyRight"},[_c('div',[_vm._v("版权所有@北京康吉森自动化设备技术有限责任公司")]),_c('div',[_vm._v("京ICP备 18061198号-1")])])
}]

export { render, staticRenderFns }